export default "__VITE_ASSET__CZEyjrwJ__"